import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  crearEstadisticas: (emisor, filter) =>
    api
      .send({
        query: gql`
          query crearEstadisticasCompras($emisor: ID!, $filter: FilterVentas!) {
            Factura {
              crearEstadisticasCompras(emisor: $emisor, filter: $filter) {
                item {
                  _id
                  nombre
                  montoTotalLinea
                  cantidad
                }
                receptor {
                  id
                  nombre
                }
                # user
                # resumenFactura {
                #   totalVentaNeta
                # }
                createdAt
              }
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Factura.crearEstadisticasCompras)
}
